require('./dist/polyfill')
